import Swal, { SweetAlertOptions } from 'sweetalert2';
import { BASE_URL } from "@/react/pages/qc/base/{utils}/constants"

// Create a custom Swal instance using mixin
const s = Swal.mixin({
	customClass: {
		confirmButton: 'btn btn-primary',
		cancelButton: 'btn btn-outline-primary',
		actions: 'flex gap-2',
		popup: 'rounded-primary bg-white text-black',
		title: 'text-black page-title',
		htmlContainer: 'text-black text-label',
		footer: 'text-black',
	},
	confirmButtonText: 'Okay',
	cancelButtonText: 'Cancel',
	closeButtonHtml: '<i class="fas fa-times"></i>',
	buttonsStyling: false,
	reverseButtons: true,
	

	// stop from focusing on the confirm button
	focusConfirm: false,
});

// Store the original fire method of the Swal instance
const originalFire = s.fire;

// Override the fire method
s.fire = async (optionsOrTitle) => {
	let options;

	if (typeof optionsOrTitle === 'string') {
		options = { title: optionsOrTitle };
	} else {
		options = optionsOrTitle || {};
	}

	if (options.icon === 'delete') {
		options.icon = undefined
		// custom icon url
		options.imageUrl = BASE_URL + "images/bin.png"
		options.imageWidth = 120
		options.imageHeight = 120
	}

	if (options.icon === 'request') {
		// imageWidth: 100,
		// imageHeight: 100,
		// imageUrl: "{{ asset('images/request-sent.svg') }}",
		options.icon = undefined
		options.imageUrl = BASE_URL + "images/request-sent.svg"
		options.imageWidth = 100
		options.imageHeight = 100
	}

	// Now call the original Swal.fire method with the updated options
	//   @ts-ignore
	return originalFire.call(s, options); // Ensure the context (`this`) is set to `s`
};

export default s;
